module.exports = __webpack_public_path__ + "static/media/vitor-pinto-mdwmx-pt-5-lv-i-unsplash@3x.ed5ea3ce.jpg";